import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
    DefaultButton,
    PrimaryButton,
} from "office-ui-fabric-react/lib-commonjs/Button";
import {
    Dialog,
    DialogType,
    DialogFooter,
} from "office-ui-fabric-react/lib-commonjs/Dialog";
import {
    setChamberType,
    showSubmitDialog,
    toggleLegacyComponentDialog,
    hideMc4500DeprecationAlert,
} from "../../actions/apptoolbar-actions";
import {
    hasManifoldInletOutletStructureChanged,
} from "../../actions/manifold-actions";
import { loginUser, logoutUser, switchIsSigningInProcess } from "../../actions/authentication-actions";
import { modalAlertActions } from "../../actions/modal-alert.actions";
import "./index.css";
import { clearRulersOnScreen } from "../../actions/drawingtoolbar-actions";
import PopUpHelper from "../../components/Calculations/popUpHelper.component";
import { startSystemGeneration, switchUnderdrain } from "../../actions/calculations-actions";
import { regionIds } from "../../lib/localization/regionIds";
import { CHAMBER_TYPE_ID_MC4500, CHAMBER_TYPE_ID_MC7200 } from '../../lib/types';
import ProjectSelectors from '../../reducers/project-reducer';

const INITIAL_ERROR_DIALOG_STATE = {
  errorDialogHidden: true,
  errorDialogMessage: '',
  errorDialogTittle: '',
};

class AppToolbar extends PureComponent {
  state = {
    INITIAL_ERROR_DIALOG_STATE,
    changeColor: true,
    showGenerateAlert: false,
    newChamberTypeKey: null,
  };

  handleOnChamberTypeSelected(evt, value) {
    const { content, lang, region, project, projectInfo, modalAlertActions } = this.props;
    let state = project ? project.state : projectInfo.state;
    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers

    if (region.id === regionIds.usa) {
      // Warn the user to prefer 7200 if they choose 4200 and are a part of the 7200 states list
      if (value.key === CHAMBER_TYPE_ID_MC4500) {
        modalAlertActions({
          text: content[lang].prefer7200Over4500Alert,
          toggle: true,
          btnText: content[lang].ok,
        });
      }
    }

    /* validate chamber transition in case attached accessories
        are not compatible with target chamber */
    let illegalAccessory = null;
    let errorMsg = '';
    let hasActiveChambers = false;
    /* validate transition */
    for (let i = 0; i < this.props.chamberRows.length; i++) {
      const r = this.props.chamberRows[i];
      if (r.getActiveCount() > 0) hasActiveChambers = true;
      illegalAccessory = r.validateTransition(value.key);
      /* if accessory is illegal */
      if (illegalAccessory) {
        errorMsg = content[lang].unableToSwitchChamberType
          .replace('{0}', content[lang][illegalAccessory.localeKey])
          .replace('{1}', value.key);
        break;
      }
    }

    if (!illegalAccessory) {
      if (!hasActiveChambers) {
        const newChamberType = this.props.chambers.find((e) => e.id === value.key);
        const newChamberEndCapType = this.props.endcaps.find((e) => e.forChamber === value.key);

        /* selecting chamber and endcap to set */
        this.props.setChamberType(newChamberType, newChamberEndCapType);
      } else {
        this.setState({
          showGenerateAlert: true,
          newChamberTypeKey: value.key,
        });
      }
    } else {
      this.setState({
        errorDialogHidden: false,
        errorDialogMessage: errorMsg,
        errorDialogTittle: this.props.content[this.props.lang].incompatibleAccessory,
      });
    }
  }

  handleCreatePDFReport() {
    this.props.togglePdfModal(true);
  }

  hideMc4500DeprecationAlert() {
    this.props.hideMc4500DeprecationAlert();
  }

  handleLegacyComponentDialogToggle(showDialog) {
    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
    this.props.toggleLegacyComponentDialog(showDialog);
  }

  changeBackground(value) {}

  render() {
    const { lang, region, content, isMC4500Deprecated } = this.props;

    const generateChambers = () => {
      this.setState({ showGenerateAlert: false });
      this.props.switchIsSigningInProcess(true);

      const newChamberType = this.props.chambers.find((e) => e.id === this.state.newChamberTypeKey);
      const newChamberEndCapType = this.props.endcaps.find((e) => e.forChamber === this.state.newChamberTypeKey);

      /* selecting chamber and endcap to set */
      this.props.setChamberType(newChamberType, newChamberEndCapType);

      setTimeout(() => {
        if (this.props.hasOutlet && !this.props.underdrain && this.props.user === null) {
          this.props.switchUnderdrain();
        }
        this.props.startSystemGeneration();
        this.props.switchIsSigningInProcess(false);
      }, 10);
    };

    return (
      <React.Fragment>
        {this.state.showGenerateAlert ? (
          <PopUpHelper
            title={content[lang].yes}
            type="alert"
            show={this.state.showGenerateAlert}
            modalActions={generateChambers}
            hideModal={() => this.setState({ showGenerateAlert: false })}
            text={content[lang].thisWillReplaceCurrentDesign}
          />
        ) : null}
        <div>
          <DefaultButton
            data-automation-id="new"
            disabled={false}
            text={this.props.chamberType ? this.props.chamberType.name : content[lang].chamber}
            menuProps={{
              onItemClick: this.handleOnChamberTypeSelected.bind(this),
              items: this.props.chambers
                .sort((a, b) => {
                  const pattern = /[^0-9]/gi;
                  const aChamberValue = a.id.replace(pattern, '');
                  const bChamberValue = b.id.replace(pattern, '');
                  return bChamberValue - aChamberValue;
                })
                .filter((val) => {
                  if (isMC4500Deprecated) {
                    return (
                      val.id !== CHAMBER_TYPE_ID_MC4500 ||
                      (this.props.project && this.props.chamberType.id === CHAMBER_TYPE_ID_MC4500)
                    );
                  } else if (val.id === CHAMBER_TYPE_ID_MC7200) {
                    return true;
                  }
                  return val.active;
                })
                .map((chamberType) => {
                  return {
                    key: chamberType.id,
                    text: chamberType.name,
                  };
                }),
            }}
            className={'drop-down-btn'}
          />
        </div>
        <Dialog
          hidden={this.state.errorDialogHidden}
          dialogContentProps={{
            type: DialogType.normal,
            title: this.state.errorDialogTittle,
            subText: this.state.errorDialogMessage,
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride',
          }}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                this.setState(INITIAL_ERROR_DIALOG_STATE);
              }}
              text={content[lang].ok}
            />
          </DialogFooter>
        </Dialog>
        <Dialog
          hidden={!this.props.showLegacyComponentDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: '',
            subText: content[lang].legacyMC4500Endcap,
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride',
          }}>
          <DialogFooter>
            <PrimaryButton onClick={this.handleLegacyComponentDialogToggle.bind(this, false)} text={content[lang].ok} />
          </DialogFooter>
        </Dialog>
        <Dialog
          hidden={!this.props.showMc4500DeprecationAlert}
          dialogContentProps={{
            type: DialogType.normal,
            title: this.props.content[lang].MC4500DeprecationAlertTitle,
            subText: this.props.content[lang].MC4500DeprecationAlert,
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride',
          }}>
          <DialogFooter>
            <PrimaryButton onClick={this.hideMc4500DeprecationAlert.bind(this)} text={this.props.content[lang].ok} />
          </DialogFooter>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
    return {
        lang: state.localization.lang,
        region: state.localization.region,
        user: state.authentication.user,
        endcaps: state.apptoolbar.endcaps,
        content: state.localization.content,
        chambers: state.apptoolbar.chambers,
        chamberType: state.globals.chamberType,
        accessories: state.apptoolbar.accessories,
        chamberRows: state.chamberbed.chamberRows,
        showEraseDialog: state.apptoolbar.showEraseDialog,
        showLogoutDialog: state.apptoolbar.showLogoutDialog,
        showLegacyComponentDialog: state.apptoolbar.showLegacyComponentDialog,
        showGenerateAlert: state.calculations.showGenerateAlert,
        hasOutlet: state.calculations.hasOutlet,
        underdrain: state.calculations.underdrain,
        totalActiveChambers: state.calculations.requiredChambers,
        project: state.project.project,
        projectInfo: state.project.projectInfo,
        isMC4500Deprecated: state.globals.isMC4500Deprecated,
        showMc4500DeprecationAlert: state.globals.showMc4500DeprecationAlert,
        featureFlag: state.globals.featureFlag,
        multiBed: state.multiBed,
        isMultiBedProject: ProjectSelectors.isMultiBedProject(),
    };
};

const mapDispatchToProps = {
    loginUser,
    logoutUser,
    setChamberType,
    showSubmitDialog,
    modalAlertActions,
    hasManifoldInletOutletStructureChanged,
    toggleLegacyComponentDialog,
    clearRulersOnScreen,
    switchIsSigningInProcess,
    startSystemGeneration,
    switchUnderdrain,
    hideMc4500DeprecationAlert,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AppToolbar);



// WEBPACK FOOTER //
// ./src/components/Toolbars/app-toolbar.js